<template>
  <div>
    <div class="header">
      <span>经营情况</span>
      <el-form :inline="true" class="header-right">
        <el-form-item>
          <el-date-picker
            style="width: 130px"
            v-model="time"
            :type="dateType"
            size="mini"
            placeholder="时间选择"
            @change="dateChange">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <el-table :data="tableData" border v-loading.body="loading" stripe style="width: 100%;">
      <el-table-tree-column
        parentKey="pid"
        treeKey="oid"
        file-icon="icon icon-file"
        folder-icon="icon icon-folder"
        prop="oname"
        label="组织"
        width="200">
      </el-table-tree-column>
      <el-table-column prop="outCount" label="门诊(人)" sortable></el-table-column>
      <el-table-column prop="atCount" label="住院(人)" sortable></el-table-column>
      <el-table-column prop="admissionCount" label="入院(人)" sortable></el-table-column>
      <el-table-column prop="leaveCount" label="出院(人)" sortable></el-table-column>
      <el-table-column prop="operationCount" label="手术(台)" sortable></el-table-column>
      <el-table-column prop="revenue" label="营收(万元)" sortable></el-table-column>
    </el-table>
  </div>
</template>

<script>
  import _ from 'lodash';
  import moment from 'moment'
  import ListUtils from '@/utils/list'
  import RecordCountService from '@/request/count/record'
  import RevenueCountService from '@/request/count/revenue'
  import ElTreeGrid from 'element-tree-grid'
  export default {
    name: "CountManage",
    components: {
      'el-table-tree-column': ElTreeGrid
    },
    data() {
      return {
        tableData: [],
        data: null,
        time: moment().startOf('day').valueOf(),
        end: moment().endOf('day').valueOf(),
        dateType: 'date',
        oids: [],
        loading: true
      }
    },
    props: {
      orgs: {
        type: Array,
        default() {
          return []
        }
      }
    },
    watch: {
      orgs() {
        this.init();
      },
    },
    created() {
      this.init();
    },
    methods: {
      init() {
        if (this.orgs.length === 0) {
          return
        }
        this.oids = [];
        _.forEach(this.orgs, val => {
          this.oids.push(val.id);
        });
        this.loadData()
      },
      loadData() {
        this.loading = true;
        if (this.time) {
          RecordCountService.countOrg({
            start: moment(this.time).startOf('day').valueOf(),
            end: moment(this.time).endOf('day').valueOf(),
            oids: this.oids.toString(),
          }).then( res => {
            this.loadRevenue(res.result || []);
          })
        }
      },
      loadRevenue(recordCountList) {
        if (this.time) {
          RevenueCountService.orggroup({
            start: moment(this.time).startOf('day').valueOf(),
            end: moment(this.time).endOf('day').valueOf(),
            oids: this.oids.toString(),
            types: '0,1,2'
          }).then( res => {
            _.forEach(res.result || [], val => {
              const index = _.findIndex(recordCountList, {oid: val.oid});
              if (index !== -1) {
                recordCountList[index].revenue = (val.total / 1000000).toFixed(2)
              }
            });
            this.data = recordCountList;
            const _tableData = ListUtils.listToTree(this.data, 'oid', 'pid', 'children');
            if (_tableData.length === 1) {
              this.tableData = _tableData[0].children
            } else {
              this.tableData = _tableData
            }
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        }
      },
      sortChange(data) {
        const prop = this.columns[_.findIndex(this.columns, {text: data.column.label})].value;
        let order = data.order;
        if (order === 'descending') {
            order = 'desc'
        } else {
            order = 'asc'
        }
        const _tableData = ListUtils.listToTree(_.orderBy(this.data, [prop], [order]), 'oid', 'pid', 'children')
        if (_tableData.length === 1) {
          this.tableData = _tableData[0].children
        } else {
          this.tableData = _tableData
        }
      },
      dateChange(){
        if (this.time) {
          this.loadData();
        }
      },
    }
  }
</script>

<style scoped>
  .header {
    height: 50px;
    line-height: 48px;
    color: #000;
    border-bottom: 1px solid #ebeef5;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    position: relative;
  }
  .header-right{
    z-index: 999;
    float: right;
    position: absolute;
    right: 0;
    top: 4px;
  }
</style >
